import React, { FC, useEffect, useMemo } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/ProvisionalClaimsPage/messges';
import { get } from 'lodash';
import moment from 'moment-timezone';
import {
  CardContainer,
  StyledTextField,
} from 'containers/ProvisionalClaimRecap/style';
import Document from 'components/Document';
import { BlobProvider } from '@react-pdf/renderer';
import InvitationLetter from 'components/InvitationLetter';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Listings } from 'containers/AppContainer/typings';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  getListBySagisKey,
  getBawabaLawyers,
} from 'containers/RecapManagerPage/utils';
import { LISTINGS } from 'containers/data-structure';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { SagisConfig } from 'containers/AppContainer/typings';
import { filterStackHolder } from 'services/utils';

export interface ProvisionalClaimInfoProps {
  intl: IntlShape;
  provisionalClaimDetails: any;
}

const ProvisionalClaimInfo: FC<ProvisionalClaimInfoProps> = (
  props,
): JSX.Element => {
  const dispatch = useDispatch();
  const provisionalClaimDetails = props.provisionalClaimDetails;
  const hearingDate = get(provisionalClaimDetails, 'hearingDate');
  useEffect(() => {
    dispatch(requestCorporealLawyers());
  }, []);
  const listings: Listings = useSelector(makeSelectListings());
  const CorporealLawyers = useSelector(makeSelectCorporealLawyers());

  const lawyer = useMemo(() => {
    const stackholders = getListBySagisKey(
      get(listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );
    const lawyers = getBawabaLawyers(stackholders, CorporealLawyers);
    const corpoLawyers = filterStackHolder(lawyers);

    return corpoLawyers.find(
      el => el.ItemKey === provisionalClaimDetails.lawyerCode,
    );
  }, [listings, CorporealLawyers, provisionalClaimDetails.lawyerCode]);

  const city = get(listings, LISTINGS.CITIES, []).find(
    (c: any) => c.ItemKey === lawyer?.townCode,
  );
  return (
    <>
      <CardContainer>
        <StyledTextField
          id="standard-basic-c"
          name="courtNumber"
          value={get(provisionalClaimDetails, 'courtNumber', '')}
          label={translate(
            {
              ...messages.monitoringProvisionalClaimAddDrawerCourtNumber,
            },
            props,
          )}
          className="input"
          InputProps={{ disableUnderline: true }}
          disabled={true}
          InputLabelProps={{ shrink: true }}
        ></StyledTextField>
        <StyledTextField
          id="standard-basic-c"
          name="hearingDate"
          value={hearingDate ? moment(hearingDate).format('DD/MM/YYYY') : ''}
          label={translate(
            {
              ...messages.monitoringProvisionalClaimAddDrawerHearingDate,
            },
            props,
          )}
          className="input"
          InputProps={{ disableUnderline: true }}
          disabled={true}
          InputLabelProps={{ shrink: true }}
        ></StyledTextField>
        <StyledTextField
          id="standard-basic-c"
          name="jurisdiction"
          value={get(provisionalClaimDetails, 'jurisdiction.title', '')}
          label={translate(
            {
              ...messages.monitoringProvisionalClaimAddDrawerJurisdiction,
            },
            props,
          )}
          className="input"
          InputProps={{ disableUnderline: true }}
          disabled={true}
          InputLabelProps={{ shrink: true }}
        ></StyledTextField>
        <StyledTextField
          id="standard-basic-c"
          name="procedureNature"
          value={get(provisionalClaimDetails, 'procedureNature.title', '')}
          label={translate(
            {
              ...messages.monitoringProvisionalClaimAddDrawerProcedureLabel,
            },
            props,
          )}
          className="input"
          InputProps={{ disableUnderline: true }}
          disabled={true}
          InputLabelProps={{ shrink: true }}
        ></StyledTextField>
        <StyledTextField
          id="standard-basic-c"
          name="jurisdictionDegree"
          value={get(provisionalClaimDetails, 'jurisdictionDegree.title', '')}
          label={translate(
            {
              ...messages.monitoringProvisionalClaimAddDrawerDegreeJurisdiction,
            },
            props,
          )}
          className="input"
          InputProps={{ disableUnderline: true }}
          disabled={true}
          InputLabelProps={{ shrink: true }}
        ></StyledTextField>
        {get(provisionalClaimDetails, 'claim.claimNumber', null) && (
          <StyledTextField
            id="standard-basic-c"
            name="claimNumber"
            value={get(provisionalClaimDetails, 'claim.claimNumber', '')}
            label={translate(
              {
                ...messages.ProvisionalClaimRecapClaimNumber,
              },
              props,
            )}
            className="input"
            InputProps={{ disableUnderline: true }}
            disabled={true}
            InputLabelProps={{ shrink: true }}
          />
        )}

        <div>
          <Document
            name={translate(messages.InvitationLetter, props)}
            type={translate(messages.InvitationLetter, props)}
            icon={
              <BlobProvider
                document={
                  <InvitationLetter
                    data={{ ...provisionalClaimDetails, lawyer, city }}
                  />
                }
              >
                {params => {
                  return (
                    <a
                      href={params.url ? params.url : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <VisibilityIcon
                        style={{ color: 'black' }}
                        className="consult"
                      />
                    </a>
                  );
                }}
              </BlobProvider>
            }
          />
        </div>
      </CardContainer>
    </>
  );
};

export default injectIntl(ProvisionalClaimInfo);
